import {
    ableProps,
    ablePropsInit,
    requiredProps,
    requiredPropsInit,
    validatorProps,
    validatorPropsInit,
    events as baseEvents,
} from '../component-base/props';

export const PHOTO_SHOW_TYPE = {
    ALL: 'all',
    SELF_ALL: 'selfAll',
    SELF_PUBLIC: 'selfPublic',
};
export const props = () => [
    ...ableProps,
    {
        key: 'placeholder',
        label: '占位文字',
        type: 'string',
    },
    {
        key: 'selectedPlaceholder',
        label: '选择后占位文字',
        type: 'string',
    },
    // {
    //     key: 'apiUrl',
    //     label: '列表接口',
    //     type: 'string',
    //     htmlContent: '<a href="https://docs.corp.kuaishou.com/d/home/fcAAt3eFBld24oAK9pOr1BzgU" target="_blank">订单列表接口查询</a>',
    // },
    ...requiredProps,
    ...validatorProps,
    {
        key: 'showWho',
        label: '展示谁的作品',
        type: 'enum',
        availableOutput: ['selectWork'],
        collection: [
            {
                label: '仅展示自己的作品（全量作品-包含隐私）',
                value: PHOTO_SHOW_TYPE.SELF_ALL,
            },
            {
                label: '仅展示自己的作品（公开作品-不包含隐私）',
                value: PHOTO_SHOW_TYPE.SELF_PUBLIC,
            },
            {
                label: '支持最近浏览+搜索作者（不包含他人隐私作品）',
                value: PHOTO_SHOW_TYPE.ALL,
            },
        ],
    },
];

export const init = () => ({
    ...ablePropsInit,
    placeholder: '请选择',
    selectedPlaceholder: '重新选择',
    apiUrl: '',
    showWho: PHOTO_SHOW_TYPE.ALL,
    ...requiredPropsInit,
    ...validatorPropsInit,
});

export const name = '选择直播';

export const component = 'mobile-general-form-live-work';


export const events = ['user-input', 'change', ...baseEvents];
